import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'material-icons/iconfont/material-icons.css';

const SW_VERSION = "2026.03.19.1";
const root = ReactDOM.createRoot(document.getElementById('root'));
const isDevelopment = process.env.NODE_ENV === "development";
const app = <App />;

root.render(
  isDevelopment ? app : <React.StrictMode>
      <App />
    </React.StrictMode>
);
if (!isDevelopment && "serviceWorker" in navigator) {
  // Register after the page loads to avoid blocking TTI
  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js?v=${encodeURIComponent(SW_VERSION)}`;
    navigator.serviceWorker.register(swUrl, {
      scope: "/"
    }).then(registration => {}).catch(err => {
      console.warn("[SW] registration failed:", err);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
